import _each from "lodash/each";
import _find from "lodash/find";
import store from "~/js/store/store";
import Vimeo from "@vimeo/player";
import { gsap, Quint, Circ, Cubic } from "gsap";
import Common from "~/js/common/common";
export default class Modal {
  constructor() {
    this.activeElement; //モーダルを開いた時にフォーカスされている箇所を保持

    this.setup();
    // 汎用性モーダル
    this.setupModal();
    // 画像スライドモーダル
    this.setupImagesModal();

    this.setupCloseModal();

    //モーダル表示時にフォーカスをモーダル内で循環させる
    this.tabCirculation();
  }
  setup() {
    this.modals = [];
    this.body = document.querySelector("body");
    store.subscribe((mutation, state) => {
      if (mutation.type === "openModal") {
        this.openModal(state.modal.activeModalName, state.modal.focusInModal);
      } else if (mutation.type === "closeModal") {
        this.closeModal(state.modal.closeModalName);
      }
    });
  }

  // 汎用性モーダルのセットアップ
  setupModal() {
    const modals = document.querySelectorAll(".js-modal-button");
    const views = document.querySelectorAll(".js-modal");
    if (!modals || !modals.length || !views) {
      return;
    }

    _each(views, (view) => {
      document.body.appendChild(view);
    });

    _each(modals, (elm, index) => {
      let modalName = elm.getAttribute("data-modal-name");
      this.modals.push({
        name: modalName
      });
      elm.addEventListener("click", (event) => {
        if (modalName) {
          event.preventDefault();
          store.dispatch("openModal", {
            name: modalName
          });
        }
      });
    });
  }

  setupCloseModal() {
    // Overlay, CloseButton
    const overlays = document.querySelectorAll(".js-modal-overlay");
    const closeButtons = document.querySelectorAll(".js-modal-close");
    if (overlays) {
      _each(overlays, (overlay) => {
        overlay.addEventListener("click", (event) => {
          event.preventDefault();
          store.dispatch("closeModal");
        });
      });
    }
    if (closeButtons) {
      _each(closeButtons, (closeButton) => {
        closeButton.addEventListener("click", (event) => {
          event.preventDefault();
          store.dispatch("closeModal");
        });
      });
    }
  }

  // 画像スライドモーダル
  setupImagesModal() {
    const modals = document.querySelectorAll(".js-imagesmodal-button");
    const view = document.querySelector(".js-imagesmodal");
    if (!modals || !modals.length || !view) {
      return;
    }

    document.body.appendChild(view);
    _each(modals, (elm, index) => {
      let modalName = elm.getAttribute("data-modal-name");
      let modalContent = elm.getAttribute("data-modal-content");
      let modalType = elm.getAttribute("data-modal-type");
      let modalIndex = elm.getAttribute("data-modal-index") || index + 1;
      this.modals.push({
        name: modalName,
        index: modalIndex,
        type: modalType,
        content: modalContent
      });
      elm.addEventListener("click", (event) => {
        if (modalName) {
          event.preventDefault();
          store.dispatch("openModal", {
            name: modalName,
            contents: modalContent,
            type: modalType,
            index: modalIndex
          });
        }
      });
    });

    // Prev, Next
    const prev = view.querySelector(".js-modal-prev");
    const next = view.querySelector(".js-modal-next");
    if (prev) {
      prev.addEventListener("click", (event) => {
        event.preventDefault();
        this.prevItem();
      });
    }
    if (next) {
      next.addEventListener("click", (event) => {
        event.preventDefault();
        this.nextItem();
      });
    }
  }

  // image, videoモーダルの内容を整形する
  createModalContents() {
    if (!this.modals && !this.modals.length) {
      return;
    }
    const _index = parseInt(store.state.modal.modalIndex, 10);
    const container = document.querySelector(".js-modal-contents");
    if (!container) {
      return;
    }
    let currentItem = _find(this.modals, (item) => {
      return parseInt(item.index, 10) === _index;
    });
    if (!currentItem) {
      return;
    }
    if (currentItem.type === "image") {
      this.createImageContents(currentItem, container);
    } else if (currentItem.type === "video") {
      this.createVideoContents(currentItem, container);
    }
  }

  // 画像コンテンツを描画
  createImageContents(item, container) {
    this.clearContents(container);
    let img = new Image();
    img.src = item.content;
    container.appendChild(img);
  }
  // Vimeoコンテンツを描画
  createVideoContents(item, container) {
    this.clearContents(container);
    let div = document.createElement("div");
    div.className = "modal-images-video";
    div.setAttribute("data-vimeo-id", item.content);
    let opt = {
      id: item.content,
      width: "100%"
    };
    container.appendChild(div);
    let player = new Vimeo(div, opt);
    player.play();
  }

  // Container内をクリア
  clearContents(container) {
    if (!container) {
      return;
    }
    let childs = container.children;
    _each(childs, (elm) => {
      elm.remove();
    });
  }

  nextItem() {
    const _index = store.state.modal.modalIndex;
    let nextIndex = parseInt(_index, 10) + 1;
    if (nextIndex > this.modals.length) {
      nextIndex = 1;
    }

    let nextItem = _find(this.modals, (item) => {
      return parseInt(item.index, 10) === nextIndex;
    });
    if (!nextItem) {
      return;
    }
    this.gotoItem(nextItem, nextIndex);
  }
  prevItem() {
    const _index = store.state.modal.modalIndex;
    let prevIndex = parseInt(_index, 10) - 1;
    if (prevIndex <= 0) {
      prevIndex = this.modals.length;
    }

    let nextItem = _find(this.modals, (item, index) => {
      return parseInt(item.index, 10) === prevIndex;
    });
    if (!nextItem) {
      return;
    }
    this.gotoItem(nextItem, prevIndex);
  }

  gotoItem(nextItem, nextIndex) {
    const container = document.querySelector(".js-modal-contents");
    gsap.to(container, {
      duration: 0.4,
      opacity: 0,
      ease: Cubic.easeOut,
      onComplete: () => {
        store.dispatch("openModal", {
          name: store.state.modal.activeModalName,
          contents: nextItem.content,
          type: nextItem.type,
          index: nextIndex
        });
        gsap.to(container, {
          delay: 0.1,
          duration: 0.4,
          opacity: 1,
          ease: Cubic.easeOut
        });
      }
    });
  }

  openModal(name, useFocus) {
    this.body.classList.add(name + "-modalopen");
    this.body.classList.add("modal-open");
    this.createModalContents();
    Common.toggleTabIndexActivate(false);
    if (Common.isSPSize()) {
      this.updateModal(name, false);
    } else {
      this.updateModal(name, useFocus);
    }

    // tab対応
    gsap.to(window, {
      duration: 0,
      scrollTo: {
        y: ".l-header"
      }
    });
  }

  updateModal(name, useFocus = true) {
    const modals = document.querySelectorAll(".js-modal");
    this.isOpenDrawer = false;
    _each(modals, (modal) => {
      const _name = modal.getAttribute("data-modal-name");
      modal.classList.remove("activemodal");
      if (name === _name) {
        this.isOpenDrawer = true;
        this.activeElement = document.activeElement;
        this.modalElements = modal.querySelectorAll("a,button,input"); //フォーカスを当てたい要素を取得
        modal.classList.add("activemodal");
        if (useFocus) {
          if (this.modalElements[0]) {
            this.modalElements[0].focus();
          } else {
            modal.focus();
          }
        } else {
        }
      }
    });
  }

  closeModal(name) {
    //let modals = document.querySelectorAll('.l-modal')
    this.body.classList.remove(name + "-modalopen");
    this.body.classList.remove("modal-open");
    const container = document.querySelector(".js-modal-contents");
    Common.toggleTabIndexActivate(true);
    this.clearContents(container);
    if (this.activeElement) this.activeElement.focus();
    /*_each(modals, (elm, index) => {
      elm.classList.remove(name)
    })*/
  }

  //モーダル表示時にフォーカスをモーダル内で循環させる
  tabCirculation() {
    this.modalElements; //フォーカスを当てたい要素
    this.isOpenDrawer = false; //開閉状態を取得
    document.addEventListener(
      "keydown",
      function (event) {
        if (this.isOpenDrawer) {
          var activeEl = document.activeElement; //フォーカスが当たっている要素
          var firstEl = this.modalElements[0]; //モーダル内でフォーカスを当てたい最初の要素
          var lastEl = this.modalElements[this.modalElements.length - 1]; //モーダル内でフォーカスを当てたい最後の要素
          var tabKey = 9 === event.keyCode; //タブキーを押されたかどうか
          var shiftKey = event.shiftKey; //シフトキーが押されたかどうか
          //最後の要素でタブキーが押された場合、最初の要素にフォーカスを当てる
          if (!shiftKey && tabKey && lastEl === activeEl) {
            event.preventDefault();
            firstEl.focus();
          }
          //最初の要素でタブキー+シフトキーが押された場合、最後の要素にフォーカスを当てる
          if (shiftKey && tabKey && firstEl === activeEl) {
            event.preventDefault();
            lastEl.focus();
          }
        }
      }.bind(this)
    );
  }
}
